import api from '@/lib/api'
import { useSetAuthState } from '../state/auth'
import { AuthAPI } from '@/types/auth'
import convertAuthClient from '../helpers/convertAuthClient'
import { isAxiosError } from 'axios'

export default function useSignInClient() {
  const setClient = useSetAuthState()

  const signInClient = async (cpfProprietario: string, password: string) => {
    try {
      const response = await api.post<AuthAPI>('/auth/login-client', { cpfProprietario, password })
      const authResponse = convertAuthClient(response.data)
      setClient(authResponse)

      return authResponse.client
    } catch (error) {
      console.error('Login error:', error)
      let message = 'Erro no servidor'
      if (isAxiosError(error) && error.response?.status === 401) {
        message = 'Credenciais inválidas'
      }
      throw new Error(`Erro ao fazer login: ${message}`)
    }
  }

  return { signInClient }
}
